import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { authTokenStore } from '@/shared/api'

export function useLogout(): () => void {
  const qc = useQueryClient()
  const navigate = useNavigate()
  return () => {
    authTokenStore.getState().setToken(null)
    qc.clear()
    void navigate({ to: '/login' })
  }
}
